<template>
  <div id="app" class="wh100">

    <transition name="fade">
      <site-preloader v-if="preloader"/>
    </transition>

    <div v-if="loaded">
      <keep-alive>
        <router-view :key="$route.fullPath"/>
      </keep-alive>
    </div>
  </div>

</template>

<script>

  import Vue from 'vue'
  import "normalize.css";
  import '@/app.scss';
  import 'flex-layout-attribute';
  import Boot from "./Boot";
  import SitePreloader from "./components/SitePreloader";

  Vue.prototype.$bus = new Vue();

  export default {
    components: {
      SitePreloader
    },
    name: 'App',
    data() {
      return {
        loaded: false,
        preloader: true
      }
    },
    methods: {
      showPreloader() {
        this.preloader = true;
      },
      hidePreloader() {
        this.preloader = false;
      }
    },
    created() {
      new Boot()
        .init()
        .then(() => {
          Boot.app = this;
          this.loaded = true;
          setTimeout(() => {
            this.preloader = false;
          }, 2000);
        })
        .catch(() => {
        });
    }
  }
</script>

<style>
  #app {
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue